import styles from "./Header.module.scss";

export default function Header() {

  return (
    <header className={styles.header}>
      <img src={"/images/logo.png"} alt="Kanak Loans" />
    </header>
  );
}
